var map = {
	"./CodeExample": "2c28",
	"./CodeExample.vue": "2c28",
	"./ComponentDoc": "0cae",
	"./ComponentDoc.vue": "0cae",
	"./ComponentItem": "42e8",
	"./ComponentItem.vue": "42e8",
	"./ComponentOptionsDoc": "940d",
	"./ComponentOptionsDoc.vue": "940d",
	"./ComponentPage": "26c9",
	"./ComponentPage.vue": "26c9",
	"./Navigation": "b34d",
	"./Navigation.vue": "b34d",
	"./PageWrapper": "f2df",
	"./PageWrapper.vue": "f2df",
	"./SectionPage": "da5d",
	"./SectionPage.vue": "da5d",
	"./global": "7218",
	"./global/": "7218",
	"./global/DesignTokens": "e4e7",
	"./global/DesignTokens.vue": "e4e7",
	"./global/IconList": "e008",
	"./global/IconList.vue": "e008",
	"./global/Markdown": "4788",
	"./global/Markdown.vue": "4788",
	"./global/TokenItem": "8673",
	"./global/TokenItem.vue": "8673",
	"./global/index": "7218",
	"./global/index.js": "7218"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a12";